<mat-dialog-content>
  <h3>Message</h3>
  <p>{{data.message}}</p>

  <h3>Properties</h3>
  <code class="ws-pre pb-4">{{data.properties}}</code>
</mat-dialog-content>
<mat-dialog-actions align="end" class="footer">
  <button trgButton color="blue-outline" class="c-grey-5" (click)="dialogRef.close()">Close</button>
</mat-dialog-actions>
